import { render, staticRenderFns } from "./RequestElement.vue?vue&type=template&id=62503657&scoped=true"
import script from "./RequestElement.vue?vue&type=script&lang=js"
export * from "./RequestElement.vue?vue&type=script&lang=js"
import style0 from "./RequestElement.vue?vue&type=style&index=0&id=62503657&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62503657",
  null
  
)

export default component.exports